var a2a_config = a2a_config || {};
a2a_config.onclick = 1;
a2a_config.menu_anchor = 'target';
a2a_config.color_main = "D7E5ED";
a2a_config.color_border = "AECADB";
a2a_config.color_link_text = "333333";
a2a_config.color_link_text_hover = "333333";
